import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  thankyouData: {
    page_name: "",
    document: [],
  },
  countryList: [],
  inquiryPopup: false,
  isAmenityOpen: false,
  isProximityOpen: false,
  inquiryPopupObj: [],
};

const inquirySlice = createSlice({
  name: "inquiry",
  initialState,
  reducers: {
    setInquiryPopup(state, action) {
      state.inquiryPopup = action.payload;
    },
    setAmenityToggle(state, action) {
      state.isAmenityOpen = action.payload;
    },
    setProximityToggle(state, action) {
      state.isProximityOpen = action.payload;
    },
    setInquiryPopupObj(state, action) {
      state.inquiryPopupObj = action.payload;
    },
    setCountryList(state, action) {
      state.countryList = action.payload;
    },
    setThankYouData(state, action) {
      state.thankyouData = action.payload;
    },
    clearThankYouData(state) {
      state.thankyouData = initialState.thankyouData;
    },
  },
});

export const {
  setInquiryPopup,
  setInquiryPopupObj,
  setCountryList,
  setThankYouData,
  clearThankYouData,
  setAmenityToggle,
  setProximityToggle,
} = inquirySlice.actions;

export default inquirySlice.reducer;
